// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"a4673c84","232":"ae4d8fd2","316":"60d93113","420":"62bcd163","736":"af9e6cac","800":"9da43b84"}[chunkId] + ".chunk.js";
};